// The threshold for a transfer to be considered short
export const SHORT_TRANSFER_THRESHOLD_IN_SECONDS = 4 * 60;
